import QRCode from 'qrcode.react'

import Avatar from 'components/Avatar'
import Header from 'components/Header'

/** @ts-ignore */
import s from './index.module.css'

import React, { useCallback, useContext, useEffect, useMemo, useState } from 'react'
import Footer from 'components/Footer'
import { useRouter } from 'next/router'
import { getWorkDetail, saveWork, getMoreWork } from 'fetch'
import { WorkspacePagePath, PreviewPagePath, PersonalCenter } from 'pagerouter'
import redirectLogin from 'fetch/redirectLogin'
import { forkNumToText, enhancedEventKeRlog } from 'util/index'
import { LOG } from 'util/constants'
import { showToast } from '@turingshequ/react-toast/src'
import { UserContext } from 'components/UserProvider'
import { CopyToClipboard } from 'react-copy-to-clipboard'
import IfRender from 'components/IfRender'
import SimpleModal from 'components/Modal/simpleModal';
import HandleLine from './HandleLine'
import MoreWork from './MoreWork'
import Comment from './Comment'
import ToReport, { REPORT_TYPE } from './ToReport'

import {IPageState} from './interface';
import Go2Personal from 'components/Go2Personal'

export default function Preview() {
  const router = useRouter()
  const { query } = router
  const [pageState, setPageState] = useState<IPageState>({
    userImage: undefined,
    workId: (router.query as any).id,
    userName: '',
    userId: '',
    releaseTime: '',
    browserNumber: 0,
    workTitle: undefined,
    isFork: 0,
    code: '',
    likeNum: undefined,
    imgUrl: undefined,
    liked: false,
    introText: '',
    iframeUrl: '',
    shortLink: '',
    codeLanguage: '',
    subTheme: '',
    collectNum: undefined,
    collected: false,
    isFirstPublish: false,
    updateTimeStr: '',
    haveReported: 0
  })

  const [shareModalVisible, setShareModalVisible] = useState(false)

  const {
    userImage,
    workId,
    userName,
    releaseTime,
    browserNumber,
    workTitle,
    isFork,
    code,
    likeNum,
    liked,
    introText,
    iframeUrl,
    shortLink,
    imgUrl,
    codeLanguage,
    subTheme,
    collected,
    collectNum,
    updateTimeStr,
    isFirstPublish,
    userId,
    haveReported
  } = pageState
  const [moreWork, setMoreWork] = useState({
    list: [],
    total: 0,
  })
  const { user, dispatch } = useContext(UserContext)
  if (router.query.id && workId !== router.query.id) {
    setPageState(s => {
      return {
        ...s,
        workId: (router.query as any).id,
      }
    })
  }
  const forkText = forkNumToText(isFork)

  const introChild = useMemo(() => {
    const ret: React.ReactNode[] = []
    if (introText != null) {
      let i = 0
      while (i < introText.length) {
        const nextPos = introText.indexOf('\n', i) || introText.indexOf(' ', i)
        if (nextPos === -1) {
          ret.push(introText.slice(i))
          i = introText.length
        } else {
          ret.push(introText.slice(i, nextPos))
          if (introText[nextPos] === '\n') {
            ret.push(<br key={i} />)
          } else if (introText[nextPos] === ' ') {
            ret.push('&nbsp;')
          }
          i = nextPos + 1
        }
      }
      return ret
    }
  }, [introText])

  useEffect(() => {
    if (workId) {
      getWorkDetail({
        id: workId as any,
      }).then((ret) => {
        const {
          code,
          description,
          createTimeStr,
          browseNum,
          title,
          type,
          userName,
          userId,
          userImage,
          likeNum,
          haveLiked,
          imgUrl,
          iframeUrl,
          shortLink,
          firstPopups,
          codeLanguage,
          subTheme,
          enshrineNum,
          haveEnshrined,
          isFirstPublish,
          updateTimeStr,
          haveReported
        } = ret.data
        setPageState((s) => {
          return {
            ...s,
            userImage,
            userName,
            userId,
            releaseTime: createTimeStr as string,
            browserNumber: browseNum,
            workTitle: title,
            isFork: type,
            code,
            likeNum,
            imgUrl,
            liked: !!haveLiked,
            iframeUrl,
            shortLink,
            codeLanguage,
            subTheme,
            introText: description || '这是我的作品，点个赞再走吧~',
            collectNum: enshrineNum,
            collected: !!haveEnshrined,
            isFirstPublish,
            updateTimeStr,
            haveReported
          }
        })
        setShareModalVisible(firstPopups === 0)

        enhancedEventKeRlog('page_enter', {
          page_name: '作品详情页',
          from: (LOG.visit_work as any)[query.from as string] || '其他',
          type: codeLanguage
        })
      }).catch(() => {
        router.push({
          pathname: '/404'
        })
      })
    }
  }, [workId])

  useEffect(() => {
    if (pageState.userId) {
      getMoreWork(pageState?.userId, workId).then((ret: any) => {
        setMoreWork(ret)
      })
    }
  }, [pageState?.userId, workId])

  const onClickForkBtn = () => {
    if (user === null) {
      redirectLogin()
      return
    }
    if (workId == null || workId == '') {
      return
    }
    if (codeLanguage !== 'python') {
      window.location.href = `${process.env.NEXT_PUBLIC_CSL_HOST}${subTheme}?id=${workId}&from=icodeshequ_adapt`
      return
    }

    return saveWork({
      code,
      title: workTitle,
      description: introText,
      type: 2,
      forkId: workId
    }).then(ret => {
      router.push({
        pathname: WorkspacePagePath,
        query: {
          workId: ret,
          from: 'icodeshequ_adapt'
        }
      })
    }, (err) => {
      if (err && err.ret && err.ret.description) {
        showToast({
          type: 'error',
            message: err.ret.description,
          })
        }
    })
  }

  const AuthorLine = useMemo(() => {
    return <div className={`${s['author-line']} ${s['author_mb23']}`}>
      <div className={s['author-line-avatar']}>
        <div>
          {userImage && userId &&
            <Go2Personal id={userId}>
              <Avatar url={userImage} size={68} />
            </Go2Personal>
          }
        </div>
      </div>
      <div className={s['author-line-content']}>
        <div className={s['author-line-content-work-name']}>
          <div>{workTitle == '' ? '未命名' : workTitle}</div>
          <div className={s['author-line-content-work-tag']} style={{ display: forkText ? undefined : 'none' }}>{forkText}</div>
        </div>
        <div className={s['author-line-content-author-name']}>
            <Go2Personal id={userId}>{userName}</Go2Personal>
        </div>
      </div>
      <div className={s.flexRight}>
        <div className={s['author-line-timestamp']}>
          {isFirstPublish ? releaseTime : `重新发布于 ${updateTimeStr}`}
        </div>
        <div className={s['author-line-view-count']}>
          <div className={`${s['author-line-icon']} ${s['eye']}`}></div>
          <div>{browserNumber}</div>
        </div>
      </div>
    </div>
  }, [userImage, userName, workTitle, releaseTime, browserNumber])

  const renderQr = () => {
    if(!shortLink){
      return null
    }

    return (
      <div className={s.previewQrContainer}>
        <div className={s.previewQrIntr}>
          <div className={s.previewQrTitle}>分享作品</div>
          <div className={s.previewQrDesc}>把作品分享出去</div>
          <div className={s.previewQrDesc}>让更多的人知道吧！</div>
        </div>
        <div>
          <div className={s.qrcode}>
            <QRCode
              value={shortLink}
              style={{
                width: 90,
                height: 90,
              }}
            />
          </div>
          <div className={s.qrtxt}>扫码分享</div>
        </div>
      </div>
    )
  }

  const renderShareModal = () => {
    if (!shareModalVisible || !shortLink) {
      return null
    }

    return (
      <div className={s.smMask}>
        <div className={s.smContainer}>
          <div className={s.smContent}>
            <div className={s.smHeader}>
              <div className={s.smTitle}>恭喜你！</div>
              <div>发布了一个天才作品呢，把作品分享出去让更多的人知道吧！</div>
            </div>
            <div className={s.smQrcode}>
              <QRCode
                value={shortLink}
                style={{
                  width: 170,
                  height: 170,
                }}
              />
            </div>
            {/* todo:处理onCopy */}
            <CopyToClipboard
              text={shortLink}
              onCopy={() => {
                showToast({
                  type: 'default',
                  message: '复制成功',
                })
              }}
            >
              <div className={s.smCopyBtn}>一键复制链接地址</div>
            </CopyToClipboard>
          </div>

          <div
            className={s.smClose}
            onClick={() => setShareModalVisible(false)}
          ></div>
        </div>
      </div>
    )
  }

  const handleWorkClick = (id: string) => {
    router.push({
      pathname: PreviewPagePath + id,
      query: {
        from: 'more',
        userId: pageState.userId
      }
    })
  }

  const handleMoreWorkClick = () => {
    router.push({
      pathname: PersonalCenter,
      query: {
        userId: btoa(pageState.userId),
      }
    })
  }

  const handleUnLogin = useCallback(() => {
    if (user === null) {
      redirectLogin()
      return true
    }
    return false
  },[user])


  const handleReportModalClose = (type = 'cancel') => {
    if(type === 'success') {
      setPageState(pre => ({...pre, haveReported: 1}))
      dispatch({ type: 'updateUnread'})
    }
    SimpleModal.close()
  }

  const handleToReportClick = (params: {
    type: REPORT_TYPE,
    id: string
  }) => {
    const {type, id} = params || {}
    console.log('举报', type, id);
    if(haveReported === 1 && type === REPORT_TYPE.work) {
      showToast({
          type: 'default',
          message: '您已举报过该作品，小图灵正在处理中，请耐心等待～',
        })
      return;
    }
    SimpleModal.show(
      <ToReport
        onClose={handleReportModalClose}
        id={id}
        type={type}
      />
    )
  }

  return (
    <>
      <Header></Header>
      <div className={['restrict-width', s['work-ct']].join(' ')}>
        {AuthorLine}
        {/* 作品区 */}
        <div className={s.previewCont}>
          {/* 左侧作品操作 */}
          {/* todo：处理iframeUrl */}
          <IfRender show={!!iframeUrl}>
            <iframe src={iframeUrl} className={s.previewFrame} />
          </IfRender>
          <IfRender show={!iframeUrl}>
            <div
              className={s.previewFrame}
              style={{
                backgroundImage: imgUrl ? `url(${imgUrl})` : '',
                backgroundSize: 'cover',
              }}
            />
          </IfRender>
          {/* 右侧作品介绍+分享 */}
          <div className={s.previewIntro}>
            <div className={s.previewTitle}>作品介绍</div>
            <div className={s.previewIntroContent}>{introChild}</div>
            {renderQr()}
          </div>
        </div>
        {/* 作品的点赞、收藏、改编 */}
        <HandleLine
            workId={workId!}
            onForkClick={onClickForkBtn}
            likedNum={likeNum}
            haveLiked={liked}
            haveCollected={collected}
            collectNum={collectNum}
            unLogin={handleUnLogin}
            onToReportClick={handleToReportClick}
            haveReported={haveReported}
        />
        {/* 评论 */}
        <div className={s.content}>
          <Comment
            user={user}
            workId={workId!}
            authorId={pageState?.userId}
            onReport={handleToReportClick}
          />
          <IfRender show={moreWork.list && moreWork.list?.length > 0}>
            <MoreWork
              list={moreWork?.list}
              onClickItem={handleWorkClick}
              onClickMore={handleMoreWorkClick}
            />
          </IfRender>
        </div>
      </div>
      <Footer />
      {renderShareModal()}
    </>
  )
}
